module.exports = __webpack_public_path__ + "img/connect_logo.dbe8406b.png";